module.exports = __webpack_public_path__ + "static/figurine_of_wondrous_power_golden_lions-3130fdd0962c408af33f639504a88905.jpg";